import * as React from 'react';

import type {Status} from 'nutshell-graphql-types';

import {PrimaryConfigureCtaButton} from './primary-configure-cta-button';
import type {PageType} from './types';

import styles from './analytics-status.module.css';

type Props = {
    pageType: PageType;
    status: Status;
    onOpenEmbedAnalyticsModal: () => void;
    onClosePopover: () => void;
};

export function NoVisitsBody(props: Props) {
    return (
        <>
            <div className={styles.text}>
                <div className='mb-16'>
                    We haven’t detected visits in a few days. Please confirm you’ve embedded the
                    correct snippet on your site.
                </div>
                <div className='flex justify-center pb-4'>
                    <PrimaryConfigureCtaButton
                        pageType={props.pageType}
                        status={props.status}
                        onClosePopover={props.onClosePopover}
                        onOpenEmbedAnalyticsModal={props.onOpenEmbedAnalyticsModal}
                    />
                </div>
            </div>
        </>
    );
}
